<template>
    <div class="main">
        <div class="top">
            <span class="title">公共资源交易中心交易日历</span>
            <div class="filter">
                <span class="label">所属区域：</span>
                <el-select v-model="regionId" clearable placeholder="请选择所属区域" size="small"
                           style="width: 180px;" @change="onRegionChange">
                    <el-option v-for="(item, index) in regionOptions"
                               :key="index"
                               :label="item.label"
                               :value="item.value"></el-option>
                </el-select>
            </div>
        </div>
        <div class="calendar">
            <div class="list">
                <el-calendar v-model="calendarValue" :first-day-of-week="7" class="calendar_data">
                    <template
                        slot="dateCell"
                        slot-scope="{date, data}">
                        <div class="calendar_item" @click="onClickGetCalendarDayDetail(data.day)">
                            <span>{{ data.day.split('-')[2] }}日</span>
                            <div v-if="hasProjectItem(data.day)&&hasProjectItem(data.day).gcCount > 0"
                                 class="type gongcheng"
                                 @click.stop="onClickGetCalendarDayDetail(data.day, 'GC')"
                            >
                                <span>工程建设</span>
                                <span class="count">{{ hasProjectItem(data.day).gcCount }}个</span>
                            </div>
                            <div v-if="hasProjectItem(data.day)&&hasProjectItem(data.day).cgCount > 0"
                                 class="type caigou"
                                 @click.stop="onClickGetCalendarDayDetail(data.day, 'CG')"
                            >
                                <span>政府采购</span>
                                <span class="count">{{ hasProjectItem(data.day).cgCount }}个</span>
                            </div>
                            <div v-if="hasProjectItem(data.day)&&hasProjectItem(data.day).cqCount > 0"
                                 class="type changquan"
                                 @click.stop="onClickGetCalendarDayDetail(data.day, 'CQ')"
                            >
                                <span>资源与产权</span>
                                <span class="count">{{ hasProjectItem(data.day).cqCount }}个</span>
                            </div>
                        </div>
                    </template>
                </el-calendar>
            </div>
            <div class="project">
                <div v-if="gCProjectList.length > 0" class="item">
                    <div class="type">
                        工程建设项目
                    </div>
                    <div v-for="item in gCProjectList" :key="item.tradeId">
                        <ProjectInfo :item="item" type="gc" />
                    </div>
                </div>
                <div v-if="cGProjectList.length > 0" class="item">
                    <div class="type">
                        政府采购项目
                    </div>
                    <div v-for="item in cGProjectList" :key="item.tradeId">
                        <ProjectInfo :item="item" type="cg" />
                    </div>
                </div>
                <div v-if="cQProjectList.length > 0" class="item">
                    <div class="type">
                        资源与产权项目
                    </div>
                    <div v-for="item in cQProjectList" :key="item.tradeId">
                        <ProjectInfo :item="item" type="cq" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProjectInfo from "./projectInfo.vue";

export default {
    components: {
        ProjectInfo
    },
    data() {
        return {
            calendarValue: new Date(),
            currentMonth: '', //当前月份（如果点击的是同一个月份，不用再请求列表数据）
            firstDayOfMonth: '', //当前月份的第一天
            lastDayOfMonth: '', //当前月份的最后一天
            regionId: '', //所属区域id
            regionOptions: [
                { value: 421201, label: '咸宁市本级' },
                { value: 421202, label: '咸安区' },
                { value: 421221, label: '嘉鱼县' },
                { value: 421222, label: '通城县' },
                { value: 421223, label: '崇阳县' },
                { value: 421224, label: '通山县' },
                { value: 421281, label: '赤壁市' },
            ],
            calendarList: [], //有项目的日期列表
            gCProjectList: [], //工程建设项目列表
            cGProjectList: [], //政府采购项目列表
            cQProjectList: [], //资源与产权项目列表
        };
    },
    watch: {
        calendarValue: {
            handler(date) {
                console.log('发生变化了啊====', date)
                // 如果点击的是同一个月份，不用再请求列表数据
                if(this.currentMonth === `${date.getFullYear()}-${date.getMonth() + 1}`) {
                    return
                }
                this.currentMonth = `${date.getFullYear()}-${date.getMonth() + 1}`
                // 获取当前月份的第一天
                const firstDay = new Date(date.getFullYear(), date.getMonth(), 2)
                // 获取当前月份的最后一天
                const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 1)
                // 格式化输出，例如 "2025-12-01"
                const formatDate = (d) => d.toISOString().split('T')[0]
                this.firstDayOfMonth = formatDate(firstDay)
                this.lastDayOfMonth = formatDate(lastDay)
                this.getCalendarList()
            },
            deep: true,
            immediate: true
        }
    },
    mounted() {

    },
    methods: {
        //获取日历列表
        getCalendarList() {
            this.$http.get(`/TradingOverview/getCalendarList?startTime=${this.firstDayOfMonth}&endTime=${this.lastDayOfMonth}&regionId=${this.regionId}`).then((res) => {
                if(res.data.code === '1') {
                    this.calendarList = res.data.data
                }
                console.log(this.calendarList)
            })
        },
        //所属区域变化，重新加载当前月份的日历数据
        onRegionChange() {
            this.gCProjectList = []
            this.cGProjectList = []
            this.cQProjectList = []
            if(this.firstDayOfMonth && this.lastDayOfMonth) {
                this.getCalendarList()
            }
        },
        //判断当前日期是否有项目
        hasProjectItem(date) {
            const item = this.calendarList.find((item) => item.days === date)
            if(item) {
                return item
            }
        },
        //点击日期获取详情
        onClickGetCalendarDayDetail(day, businessType) {
            const params = {
                day,
                businessType,
                regionId: this.regionId,
            }
            this.$http.post(`/TradingOverview/getCalendarDayDetail`, params).then((res) => {
                if(res.data.code === '1') {
                    this.gCProjectList = res.data.data.gCList || []
                    this.cGProjectList = res.data.data.cGList || []
                    this.cQProjectList = res.data.data.cQList || []
                }
            })
        },
    },
};
</script>

<style lang="less" scoped>
.main {
    height: 100%;
    margin: 0 -24px;
    .top {
        width: 100%;
        height: 48px;
        padding: 11px 24px;
        background: #FFF;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        .title {
            color: #000000;
            font-size: 18px;
            font-weight: 600;
        }
        .filter {
            display: flex;
            flex-direction: row;
            align-items: center;
            .label {
                color: #000000d9;
                font-size: 14px;
            }
        }
    }
    .calendar {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        .list {
            background: #FFFFFF;
            flex: 1;
            height: 100%;
            margin: 24px;
            .calendar_data{
                /deep/ .el-calendar__body{
                    .el-calendar-day{
                        height: 126px;
                        .calendar_item {
                            height: 100%;
                            display: flex;
                            flex-direction: column;
                            gap: 3px;
                            .type {
                                width: 100%;
                                height: 28px;
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                border-radius: 4px;
                                padding: 8px;
                                cursor: pointer;
                                span {
                                    color: #000000d9;
                                }
                            }
                            .gongcheng {
                                border-left: 2px solid #2568EC;
                                background: #F0F7FF;
                                .count {
                                    color: #2568EC;
                                }
                            }
                            .caigou {
                                border-left: 2px solid #FA8C16;
                                background: #FFF7E6;
                                .count {
                                    color: #FA8C16;
                                }
                            }
                            .changquan {
                                border-left: 2px solid #13C2C2;
                                background: #E6FFFB;
                                .count {
                                    color: #13C2C2;
                                }
                            }
                        }
                    }
                    .el-calendar-table thead th {
                        color: #000000d9;
                        text-align: center;
                        background: #E3ECFB;
                        height: 48px;
                    }
                    .el-calendar-table thead th:before {
                        color: #000000d9;
                        content: '星期';
                    }
                }
                /deep/.el-calendar__header {
                    border-bottom: none;
                    position: relative;

                    .el-calendar__title {
                        color: #000000d9;
                        font-size: 18px;
                        font-weight: 600;
                        position: absolute;
                        left: 50%;
                        transform: translate(-50%);
                    }
                    .el-calendar__button-group {
                        width: 100%;
                    }
                    .el-button-group {
                        display: flex;
                        justify-content: space-between;
                    }
                    .el-button-group:after, .el-button-group:before {
                        content: unset;
                    }
                    .el-button-group>.el-button:not(:first-child):not(:last-child) {
                        display: none;
                    }
                    .el-button-group>.el-button {
                        width: 32px;
                        height: 32px;
                        padding: 8px;
                    }
                    .el-button-group>.el-button:first-child:before {
                        //content: '<';
                        //font-size: 16px;
                        content: "";
                        display: inline-block;
                        width: 16px;
                        height: 16px;
                        padding: 8px;
                        background-image: url('../../../../assets/images/icon_left.png');
                        background-size: contain;
                        background-repeat: no-repeat;
                        background-position: center;
                    }
                    .el-button-group>.el-button:last-child:before {
                        //content: '>';
                        //font-size: 16px;
                        content: "";
                        display: inline-block;
                        width: 16px;
                        height: 16px;
                        padding: 8px;
                        background-image: url('../../../../assets/images/icon_right.png');
                        background-size: contain;
                        background-repeat: no-repeat;
                        background-position: center;
                    }
                    .el-button-group>.el-button:first-child span,
                    .el-button-group>.el-button:last-child span {
                        display: none;
                    }
                }
            }
        }
        .project {
            overflow: auto;
            display: flex;
            width: 412px;
            margin-bottom: 24px;
            flex-shrink: 0;
            flex-direction: column;
            background: #FFF;
            padding: 12px 16px;
            gap: 12px;
            .item {
                display: flex;
                flex-direction: column;
                gap: 16px;
                .type {
                    color: #000000d9;
                    font-size: 16px;
                    font-weight: 600;
                    border-left: 3px solid #2568EC;
                    padding-left: 10px;
                    margin-bottom: -4px;
                }
            }
        }
    }
}

</style>
